import { Button, DataSource, HorizontalSpacer, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutImportSnapshot extends Layout {
    buttonImportSnapshot: Button;
    buttonSelectAll: Button;
    buttonUnselectAll: Button;
    horizontalspacer1: HorizontalSpacer;
    sourceImportSnapshotData: DataSource;
    tableImport: Table;
}
